/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterBinderClaimPaymentHistoryQueryDto
 */
export interface FilterBinderClaimPaymentHistoryQueryDto {
    /**
     * Contract ID to filter payment history
     * @type {string}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    contractId?: string;
    /**
     * Transaction date from
     * @type {Date}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    transactionDateFrom?: Date;
    /**
     * Transaction date to
     * @type {Date}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    transactionDateTo?: Date;
    /**
     * Transaction types to filter
     * @type {Array<string>}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    transactionTypes?: Array<FilterBinderClaimPaymentHistoryQueryDtoTransactionTypesEnum>;
    /**
     * Currencies to filter (settlement currency)
     * @type {Array<string>}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    currencies?: Array<string>;
    /**
     * Payment statuses to filter
     * @type {Array<string>}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    paymentStatuses?: Array<FilterBinderClaimPaymentHistoryQueryDtoPaymentStatusesEnum>;
    /**
     * Bank account numbers to filter (From Pinnacle Bank Account)
     * @type {Array<string>}
     * @memberof FilterBinderClaimPaymentHistoryQueryDto
     */
    bankAccountNumbers?: Array<string>;
}


/**
 * @export
 */
export const FilterBinderClaimPaymentHistoryQueryDtoTransactionTypesEnum = {
    Payment: 'Payment',
    ReserveChangeOnly: 'Reserve Change Only'
} as const;
export type FilterBinderClaimPaymentHistoryQueryDtoTransactionTypesEnum = typeof FilterBinderClaimPaymentHistoryQueryDtoTransactionTypesEnum[keyof typeof FilterBinderClaimPaymentHistoryQueryDtoTransactionTypesEnum];

/**
 * @export
 */
export const FilterBinderClaimPaymentHistoryQueryDtoPaymentStatusesEnum = {
    AwaitingApproval: 'Awaiting Approval',
    Approved: 'Approved',
    NotApproved: 'Not Approved',
    Paid: 'Paid'
} as const;
export type FilterBinderClaimPaymentHistoryQueryDtoPaymentStatusesEnum = typeof FilterBinderClaimPaymentHistoryQueryDtoPaymentStatusesEnum[keyof typeof FilterBinderClaimPaymentHistoryQueryDtoPaymentStatusesEnum];


/**
 * Check if a given object implements the FilterBinderClaimPaymentHistoryQueryDto interface.
 */
export function instanceOfFilterBinderClaimPaymentHistoryQueryDto(value: object): value is FilterBinderClaimPaymentHistoryQueryDto {
    return true;
}

export function FilterBinderClaimPaymentHistoryQueryDtoFromJSON(json: any): FilterBinderClaimPaymentHistoryQueryDto {
    return FilterBinderClaimPaymentHistoryQueryDtoFromJSONTyped(json, false);
}

export function FilterBinderClaimPaymentHistoryQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterBinderClaimPaymentHistoryQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractId': json['contractId'] == null ? undefined : json['contractId'],
        'transactionDateFrom': json['transactionDateFrom'] == null ? undefined : (new Date(json['transactionDateFrom'])),
        'transactionDateTo': json['transactionDateTo'] == null ? undefined : (new Date(json['transactionDateTo'])),
        'transactionTypes': json['transactionTypes'] == null ? undefined : json['transactionTypes'],
        'currencies': json['currencies'] == null ? undefined : json['currencies'],
        'paymentStatuses': json['paymentStatuses'] == null ? undefined : json['paymentStatuses'],
        'bankAccountNumbers': json['bankAccountNumbers'] == null ? undefined : json['bankAccountNumbers'],
    };
}

export function FilterBinderClaimPaymentHistoryQueryDtoToJSON(json: any): FilterBinderClaimPaymentHistoryQueryDto {
    return FilterBinderClaimPaymentHistoryQueryDtoToJSONTyped(json, false);
}

export function FilterBinderClaimPaymentHistoryQueryDtoToJSONTyped(value?: FilterBinderClaimPaymentHistoryQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractId': value['contractId'],
        'transactionDateFrom': value['transactionDateFrom'] == null ? undefined : ((value['transactionDateFrom']).toISOString()),
        'transactionDateTo': value['transactionDateTo'] == null ? undefined : ((value['transactionDateTo']).toISOString()),
        'transactionTypes': value['transactionTypes'],
        'currencies': value['currencies'],
        'paymentStatuses': value['paymentStatuses'],
        'bankAccountNumbers': value['bankAccountNumbers'],
    };
}

